import moment from 'moment';

declare interface ErrorObject {
  [key: string]: string;
}

export const validate1 = (values: CreateOffer) => {
  const errors: ErrorObject = {};
  if (!values.title) errors.title = "Title can't be empty";
  if (!values.subtitle) errors.subtitle = "Title can't be empty";
  if (!values.type) errors.type = "Offer type can't be empty";
  if (!values.description) errors.description = "Description can't be empty";
  if (values.categories === undefined || values.categories.length === 0)
    errors.categories = 'Have to select at least one category';

  if (values.type === 'job') {

    if (!values.display_start_date) errors.display_start_date = 'Start time is required';
    if (!values.display_end_date) errors.display_end_date = 'Start time is required';
  }

  return errors;
};

export const validate2 = (values: CreateOffer) => {

  const errors: ErrorObject = {};
  if (!values.shared_spots && !values.male_spots && !values.female_spots)
    errors.shared_spots = 'Have to choose something for spots';
  
  if (values.is_group) {
    if (isNaN(parseInt(values.group_min_size)))
      errors.group_min_size = 'Minimum group size is not a number';
    if (isNaN(parseInt(values.group_max_size)))
      errors.group_max_size = 'Maximum group size is not a number';
    if (isNaN(parseInt(values.group_max_number)))
      errors.group_max_number = 'Maximum group number is not a number';
  }

  if (['anytime', 'reservation_required', 'job'].indexOf(values.type) === -1) {

    if (!values.starts_at) errors.starts_at = 'Start time is required';
  }

  if (values.age_limit && values.age_limit < 18) {
    errors.age_limit = "Age limit can't be under 18";
  }
  if (values.age_limit && values.age_limit > 100) {
    errors.age_limit = "Age limit can't be over 100";
  }
  if (values.type === 'timed' || values.type === 'swing_by') {
    if (!values.ends_at) errors.ends_at = 'End time is required';
  }

  if (!values.repeat_type && values.type !== 'job') {
    errors.repeat_type = 'Repeat type is required';
  }

  if (values.starts_at || values.ends_at) {

    if (values.starts_at && values.ends_at && moment(values.starts_at).isAfter(moment(values.ends_at))) {
      errors.starts_at = "Start can't be after end";
    }

    if (values.starts_at && moment(values.starts_at).isBefore(moment()))
      errors.starts_at = "Start can't be before now";

  } else if (values.visible_from || values.visible_until) {

    if (values.visible_from && values.visible_until && moment(values.visible_from).isAfter(moment(values.visible_until))) {
      errors.visible_from = "Start can't be after end";
    }

    if (values.visible_from && moment(values.visible_from).isBefore(moment()))
      errors.visible_from = "Start can't be before now";
  }
  
  if (values.type === 'timed' || values.type === 'swing_by') {
    if (!values.ends_at) errors.ends_at = 'End time is required';
  }

  if (values.type === 'reservation_required') {
    if (!values.reservation_method) errors.reservation_method = 'Reservation method is required';
    if (!values.reservation_data) errors.reservation_data = 'Reservation details are required';
  }
  return errors;
};
